// Regras dos campos extras de um item de catálogo.
//
// Separado de `components/base/CamposExtras.tsx` porque o arquivo do componente
// só exporta componentes — é o que o Fast Refresh exige, e é também a divisão
// que o resto do projeto usa: `lib/` guarda a regra, `components/` desenha.

import type { CampoExtra } from '@/lib/catalogo';

/**
 * Confere os obrigatórios declarados no catálogo.
 *
 * Devolve a mensagem do primeiro campo em falta, ou `null`. O banco não impõe
 * isto — a constraint `infraestrutura_itens_campos_check` confere a **forma** do
 * JSON, não o preenchimento das respostas —, então aqui é onde a exigência
 * declarada pelo admin vira exigência de verdade.
 */
export function validarCamposExtras(
  campos: CampoExtra[],
  valores: Record<string, unknown>,
): string | null {
  for (const campo of campos) {
    if (!campo.obrigatorio) continue;
    const valor = valores[campo.chave];
    const vazio =
      valor === null ||
      valor === undefined ||
      valor === '' ||
      (Array.isArray(valor) && valor.length === 0);
    if (vazio) return `Preencha "${campo.rotulo}".`;
  }
  return null;
}
